<template>
    <div class="cz3__form-fields-main-scroll">
        <slot/>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__form-fields-main-scroll {
            display: flex;
            flex-direction: column;

            gap: 16px;

            @include respond-above(sm) {
                flex: 1 0 0;

                // margin-left: -4px;
                // margin-right: -4px;

                padding-left: 32px;
                padding-right: 32px;

                gap: 26px;

                overflow: auto;
                -webkit-overflow-scrolling: touch;
            }
        }
    }
</style>

<script>
    export default {
    };
</script>
